/**
 * Returns whether the given strings, arrays and objects are empty or not
 *
 * @param {undefined|String|Number|Object|Array} value
 *
 * @returns {Boolean} The emptiness of given value
 */
const isEmpty = (value) =>
  value == null ||
  value == undefined ||
  value === "" ||
  Number.isNaN(value) ||
  (Array.isArray(value) && (value.length === 0 || value.every((v) => isEmpty(v)))) ||
  (typeof value === "object" && (Object.keys(value).length === 0 || Object.values(value).every((v) => isEmpty(v))));

export default isEmpty;
